<script lang="ts">
    import { onMount } from "svelte";
    import { replaceRoute } from "@/utils/router";

    onMount(async () => {
        replaceRoute("/login");
    });
</script>
